<template>
  <svg class="c-module__percentage me-2">
  <circle
    cx="11"
    cy="11"
    r="10"
    fill="none"
    stroke-width="3px"
    stroke-dasharray="65"
    stroke-dashoffset="0"
    stroke="rgba(184, 184, 184, 0.3)"></circle>
  <circle
    cx="11"
    cy="11"
    r="10"
    fill="none"
    stroke-width="3px"
    stroke-dasharray="65"
    :stroke-dashoffset="65 - (65 * percentage) / 100"
    stroke="#9c3"></circle>
  </svg>
</template>

<script>
export default {
  props: ['percentage'],
};
</script>
